import Vue from 'vue';
import ElPreviewer from '../ElPreviewer.vue';

/**
 * https://github.com/wszxdhr/vue-directive-image-previewer
 * 图片放大预览
 * 使用方法: v-preview="img" 或 v-preview="[imgs]" 或 v-preview="{config}"
 * 可配置参数如下:
 * 			background:		背景色
 * 			cursor:			鼠标指针样式
 * 			zIndex:			z轴索引
 * 			maxWidth:		最大宽度
 * 			maxHeight:		最大高度
 * 			previewSize:	预览尺寸, 设置后将使用该尺寸与图片尺寸中较小的值;
 * 
 */

const ImagePreviewer = Vue.extend(ElPreviewer);
export default {
	bind (el: HTMLElement, binding: any, vnode: any) {
		const handler = (evt: any) => {
			let instance: any = new ImagePreviewer();
			let bingdingObj = (el as any)._preview;
			let imgSrc = bingdingObj.src || bingdingObj.vnode.data.attrs.src || bingdingObj.vnode.componentInstance.src;
			let rect = evt.target.getBoundingClientRect();
			let { width, height, top, left } = rect;
			instance.pictureSize = { width: width, height: height, top: top, left: left };
			bingdingObj.maxWidth !== undefined && (instance.maxWidth = bingdingObj.maxWidth);
			bingdingObj.maxHeight !== undefined && (instance.maxHeight = bingdingObj.maxHeight);
			bingdingObj.previewSize !== undefined && (instance.previewSize = bingdingObj.previewSize);
			instance.cursor = bingdingObj.cursor;
			instance.animate = bingdingObj.animate;
			instance.zIndex = bingdingObj.zIndex;
			instance.vm = instance.$mount();
			instance.vm.src = [ imgSrc ];
			instance.vm.background = bingdingObj.background;
			instance.dom = instance.vm.$el;
			instance.sourceDom = evt.target;
			instance.vm.$on('close', () => {
				return () => {
					instance.vm.$destroy();
					document.body.removeChild(instance.vm.$el);
				};
			});
			instance.vm.$nextTick(() => {
				setTimeout(() => {
					instance.vm.open();
				}, 0);
			});
			document.body.appendChild(instance.dom);
		};
		(el as any)._preview_handler = handler;
		el.addEventListener('click', handler);
	},
	inserted (el: HTMLElement, binding: any, vnode: any) {},
	update (el: HTMLElement, binding: any, vnode: any) {
		let src: string | Array<string>;
		let background: any;
		let cursor: any;
		let animate: any = { duration: 100 };
		let zIndex: any;
		let maxWidth: any;
		let maxHeight: any;
		let previewSize: any;
		let isObject: any = (val: any) => Object.prototype.toString.call(binding.value) == '[object Object]';
		let isString: any = (val: any) => Object.prototype.toString.call(binding.value) == '[object String]';
		let isArray: any = (val: any) => Object.prototype.toString.call(binding.value) == '[object Array]';
		if (isString(binding.value) || isArray(binding.value)) {
			src = binding.value;
		} else if (isObject(binding.value)) {
			src = binding.value.src;
			background = binding.value.background;
			cursor = binding.value.cursor;
			animate = binding.value.animate;
			zIndex = binding.value.zIndex;
			maxWidth = binding.value.maxWidth;
			maxHeight = binding.value.maxHeight;
			previewSize = binding.value.previewSize;
		} else {
			console.log('preview: 无效的预览设置!');
			return;
		}
		(el as any)._preview_ = {
			vnode,
			src,
			background,
			cursor,
			animate,
			zIndex,
			maxWidth,
			maxHeight,
			previewSize,
		};
	},
	componentUpdated (el: HTMLElement, binding: any, vnode: any) {},
	unbind (el: HTMLElement, binding: any, vnode: any) {
		el.removeEventListener('click', (el as any)._preview_handler);
	},
};
